'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import { cn } from '@src/utils/ui';
import { ServiceBadge } from '../service-badge/service-badge';

export const NewServiceBadge = ({ className = '' }) => {
    return (
        <ServiceBadge
            className={cn(
                'tw-gap-[4px] tw-bg-primary-500 tw-flex tw-justify-center tw-items-center tw-text-white tw-rounded-[4px]',
                className
            )}
        >
            <span className='tw-text-[12px] tw-font-[700]'>New Service</span>
        </ServiceBadge>
    );
};

NewServiceBadge.propTypes = {
    className: PropTypes.string
};
